import type { Cloud } from './types';
import { CloudAccountType } from './types';
import { AppleCloud } from './appleCloud';
import { GoogleCloud } from './googleCloud';

export const createCloudFactory = (type?: CloudAccountType): Cloud => {
  switch (type) {
    case CloudAccountType.apple:
      return new AppleCloud();
    case CloudAccountType.google:
      return new GoogleCloud();
    default:
      return new GoogleCloud();
  }
};
